import { makeAlert } from '@/utils'
import { usePublishStore } from '@/stores/usePublishStore'
import { getUseFeedChoiceKey, parseUseFeedChoice } from '@/utils/onboardingFeedChoice'

export function getOnboardingUsesImportFeed(accountId: string): boolean {
  try {
    const raw = sessionStorage.getItem(getUseFeedChoiceKey(accountId))
    return parseUseFeedChoice(raw) === true
  } catch {
    return false
  }
}

export async function triggerOnboardingPublish(params: {
  iseEndpoint: string
  accountId: string
  usesImportFeed: boolean
}): Promise<void> {
  const publishStore = usePublishStore()

  const triggered = await publishStore.publishChanges(params.iseEndpoint, params.accountId)

  if (!triggered) {
    const publishError = publishStore.lastPublishError as
      | { message?: string; error?: string; messages?: string[] }
      | null
    const message =
      publishError?.message ||
      publishError?.error ||
      publishError?.messages?.join('; ') ||
      'Publish could not be started.'
    throw new Error(message)
  }

  makeAlert(
    params.usesImportFeed
      ? 'Onboarding complete! Publish started and your inventory feed is now processing.'
      : 'Onboarding complete! Publish started—your configuration changes are being promoted.',
    'success',
  )
}
